module.exports = __webpack_public_path__ + "static/diaconia_737x621-a71a54cb0961ba89a2a0f64a7611206c.webp";